import React, { useState } from "react";
import { Form, Input } from "antd";
import { yesNoOptions } from "../../../../Options/commonOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";

const Swellings = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  return (
    <>
      <DeselectableRadioGroup
        label={"Swellings"}
        name={"swellings"}
        options={yesNoOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {form.getFieldValue("swellings") === "yes" && (
        <Form.Item name="swelling_description">
          <Input.TextArea
            rows={3}
            type="text"
            placeholder="Description"
            style={{ width: "100%" }}
          />
        </Form.Item>
      )}
    </>
  );
};

export default Swellings;
